import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Annotation } from '../models/Annotation';
import { SearchInput } from '../models/SearchInput';
import { User } from '../../components/access-management/access-management.component';

@Injectable({
  providedIn: 'root'
})
export class CommonDataService {

  constructor() { }

  navData = new BehaviorSubject({
    crumbData: [],
    menuData: [],
  });

  pageUrl = new BehaviorSubject<string>("");
  showRightPanel = new BehaviorSubject<boolean>(false);
  rightPanelWidth = new BehaviorSubject<string>("");
  currentParagraph = new BehaviorSubject<string>("");
  rightOverlayOption = new BehaviorSubject<string>("");
  notificationObject = new BehaviorSubject({
    type: "",
    displayTime: 0,
    position: "",
    message: "",
  });
  annotationContent = new BehaviorSubject<Annotation>(null);
  acceptCookie = new BehaviorSubject<boolean>(false);
  resetPrintQueue = new BehaviorSubject<boolean>(true);
  searchInput = new BehaviorSubject<SearchInput>(null);
  bookmarkId = new BehaviorSubject<string>("");
  letfNavData = new BehaviorSubject({});
  userId = new BehaviorSubject<string>("");
  mailId = new BehaviorSubject<string>("");
  emailId = new BehaviorSubject<string>("");
  addAnnotationParagraphId = new BehaviorSubject<string>("");
  deleteAnnotationParagraphId = new BehaviorSubject<string>("");
  addBookmarkParagraphId = new BehaviorSubject<string>("");
  deleteBookmarkParagraphId = new BehaviorSubject<string>("");
  closeModalOption = new BehaviorSubject<boolean>(false);
  closeandActionOption = new BehaviorSubject<boolean>(false);
  showLoader = new BehaviorSubject<boolean>(false);
  isConfirmationPopUpOpen = new BehaviorSubject<boolean>(false);
  annotationWithinContent = new BehaviorSubject<string>("");
  printqueueCount = new BehaviorSubject<string>("");
  myannotation = new BehaviorSubject<string>("");
  annotationUpdateSource = new BehaviorSubject<string>("");
  updateAnnotationParagraphId = new BehaviorSubject<string>("");
  displayallannotation = new BehaviorSubject<string>("");
  printCount = new BehaviorSubject<string>("");
  printwithannotations = new BehaviorSubject<string>("");
  printpreviewFileName = new BehaviorSubject<string>("");
  printToggleOff = new BehaviorSubject<string>("");
  tcsource = new BehaviorSubject<string>("");
  tcprint = new BehaviorSubject<boolean>(false);
  printContentHideShow = new BehaviorSubject<string>("");
  pdfName = new BehaviorSubject<string>("");
  archiveContentPage = new BehaviorSubject<boolean>(false);
  canactivate = new BehaviorSubject<boolean>(false);
  breadcrumbPath = new BehaviorSubject<string>("");
  navDataContentPage = new BehaviorSubject<any>([]);
  rightOverlayContentPageID = new BehaviorSubject({
    pubId: "",
    pageId: ""
  });
  aaaUserMessage = new BehaviorSubject<boolean>(false);
  crossreferencedParaID = new BehaviorSubject<string>("");
  openSearchMenu = new BehaviorSubject<string>("");
  EditFromContentPage = new BehaviorSubject<boolean>(false);
  CrossRefReportNotGenerated = new BehaviorSubject<boolean>(true);
  NavigatingFromComponent = new BehaviorSubject<string>("");
  childComponent = new BehaviorSubject<boolean>(false);
  searchPageRefresh = new BehaviorSubject<string>("");
  glossaryTermData = new BehaviorSubject<any>([]);
  refreshValidation = new BehaviorSubject<boolean>(false);
  removeAnnotationFromArray = new BehaviorSubject<string>("");
  selectednavindex = new BehaviorSubject<any>([]);
  parentlevelshowallinone = new BehaviorSubject<boolean>(false);
  currentParagraphId = new BehaviorSubject<string>("");
  glossaryTermId = new BehaviorSubject<string>("");
  globalLabels=new BehaviorSubject<any>({});
  glossaryTermBackButtonClicked=new BehaviorSubject<boolean>(false);
  glossarytermbackbuttontabinformation=new BehaviorSubject<any>("");
  glossaryTerm = new BehaviorSubject<string>("");
  glossaryTermFromContentPageBackButton = new BehaviorSubject<string>("");
  glossaryselectedAlphabet = new BehaviorSubject<string>("");
  parentComponentDetails=new BehaviorSubject<any>([]);
  backbutton_sourcetracing=new BehaviorSubject<any>(false);
  isSourceTracingLinkClicked = new BehaviorSubject<any>(false);
  glossarytermfilterkey = new BehaviorSubject<string>("");
  currentSortHeaderSTT = new BehaviorSubject<string>("");
  currentSortDirectionSTT = new BehaviorSubject<string>("");
  userAddedUpdated = new BehaviorSubject<boolean>(false);
  userData = new BehaviorSubject<User>(null);
  loadCurrentLeftNav = new BehaviorSubject<string>(null);
  openSearchFromOutSide = new Subject<void>();
}
